import { render, staticRenderFns } from "./Zigzags.vue?vue&type=template&id=0598c696&"
import script from "./Zigzags.vue?vue&type=script&lang=js&"
export * from "./Zigzags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports